<template>
  <Loader v-if="loader" />
  <div class="card">    
    <div class="p-card p-4 mb-3">
      <h4>POD Non Fatturati Ultimo Mese</h4>
      <DataTable :value="podNonFatturati" 
                class="p-datatable-sm" 
                responsiveLayout="scroll"
                stripedRows 
                :paginator="podNonFatturati.length > 10" 
                :rows="10">
        <Column field="code" header="POD" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToPodDetail(slotProps.data.pod_id)">
              {{ slotProps.data.code }}
            </a>
          </template>
        </Column>
        <Column field="numero_fattura" header="Numero" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero_fattura)">
              {{ slotProps.data.numero_fattura }}
            </a>
          </template>
        </Column>

        <Column field="code_contratto" header="Contratto" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="name" header="Periodo" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="cliente" header="Cliente" headerStyle="width: 20%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.cliente_id)">
              {{ getClienteCompleto(slotProps.data) }}
            </a>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante" headerStyle="width: 20%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentante_id)">
              {{ slotProps.data.rappresentante }}
            </a>
          </template>
        </Column>
        <Column field="agente" header="Agente" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agente_id)">
              {{ slotProps.data.agente }}
            </a>
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="p-card p-4 mb-3">
      <h4>PDR Non Fatturati Ultimo Mese</h4>
      <DataTable :value="pdrNonFatturati" 
                class="p-datatable-sm" 
                responsiveLayout="scroll"
                stripedRows 
                :paginator="pdrNonFatturati.length > 10" 
                :rows="10">
        <Column field="code" header="PDR" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToPdrDetail(slotProps.data.pdr_id)">
              {{ slotProps.data.code }}
            </a>
          </template>
        </Column>
        <Column field="numero_fattura" header="Numero" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToFatturaDetail(slotProps.data.numero_fattura)">
              {{ slotProps.data.numero_fattura }}
            </a>
          </template>
        </Column>

        <Column field="code_contratto" header="Contratto" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="name" header="Periodo" headerStyle="width: 10%; text-align: left" bodyStyle="text-align: left"></Column>
        <Column field="cliente" header="Cliente" headerStyle="width: 20%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToClienteDetail(slotProps.data.cliente_id)">
              {{ getClienteCompleto(slotProps.data) }}
            </a>
          </template>
        </Column>
        <Column field="rappresentante" header="Rappresentante" headerStyle="width: 20%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToRappresentanteDetail(slotProps.data.rappresentante_id)">
              {{ slotProps.data.rappresentante }}
            </a>
          </template>
        </Column>
        <Column field="agente" header="Agente" headerStyle="width: 15%; text-align: left" bodyStyle="text-align: left">
          <template #body="slotProps">
            <a href="#" @click.prevent="navigateToAgenteDetail(slotProps.data.agente_id)">
              {{ slotProps.data.agente }}
            </a>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-fatturazione/fatturazione-service'
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useToast } from "primevue/usetoast";
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
    setup() {
      const loader = ref(false);
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus;
      self.$http = self.appContext.config.globalProperties.$http;
      const service = new Service(self.$http, self.$eventBus);
      const toast = useToast();
      
      const podNonFatturati = ref([]);
      const pdrNonFatturati = ref([]);

      const getClienteCompleto = (data) => {
        if (data.ragsoc) return data.ragsoc;
        return `${data.nome} ${data.cognome}`.trim();
      };

      const loadAllData = async () => {
        try {
          loader.value = true;
          const [responsePod, responsePdr] = await Promise.all([
            service.getCheckNonFatturati(),
            service.getCheckNonFatturatiGas()
          ]);
          
          podNonFatturati.value = responsePod;
          pdrNonFatturati.value = responsePdr;
          
          toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Dati caricati correttamente',
            life: 3000
          });
        } catch (error) {
          toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore nel caricamento dei dati',
            life: 3000
          });
        } finally {
          loader.value = false;
        }
      };

      const showToast = (severity, summary, detail) => {
        toast.add({
          severity,
          summary,
          detail,
          life: 3000
        });
      };

      const navigateToAgenteDetail = (agenteId) => {
        if (!agenteId) {
          showToast('warn', 'Attenzione', 'ID agente non disponibile');
          return;
        }
        window.open(`/ask/agenti/${agenteId}/dettagli`);
      };
      
      const navigateToRappresentanteDetail = (rappresentanteId) => {
        if (!rappresentanteId) {
          showToast('warn', 'Attenzione', 'ID rappresentante non disponibile');
          return;
        }
        window.open(`/ask/rappresentanti/${rappresentanteId}/dettagli`);
      };
      
      const navigateToFatturaDetail = (numero) => {
        if (!numero) {
          showToast('warn', 'Attenzione', 'Numero fattura non disponibile');
          return;
        }
        window.open(`/ask/clienti/fatture/${numero}/dettagli`);
      };
      
      const navigateToClienteDetail = (clienteId) => {
        if (!clienteId) {
          showToast('warn', 'Attenzione', 'ID cliente non disponibile');
          return;
        }
        window.open(`/ask/clienti/${clienteId}/dettagli`);
      };

      const navigateToPodDetail = (podId) => {
        if (!podId) {
          showToast('warn', 'Attenzione', 'ID POD non disponibile');
          return;
        }
        window.open(`/ask/pods/${podId}/dettagli`);
      };

      const navigateToPdrDetail = (pdrId) => {
        if (!pdrId) {
          showToast('warn', 'Attenzione', 'ID PDR non disponibile');
          return;
        }
        window.open(`/ask/pdrs/${pdrId}/dettagli`);
      };

      onMounted(() => {
        loadAllData();
      });

      return {
        loader,
        podNonFatturati,
        pdrNonFatturati,
        getClienteCompleto,
        navigateToAgenteDetail,
        navigateToRappresentanteDetail,
        navigateToFatturaDetail,
        navigateToClienteDetail,
        navigateToPodDetail,
        navigateToPdrDetail
      };
    }
}
</script>

<style scoped>
.card {
  background-color: #f4f4f4;
  padding: 16px;
  border-radius: 4px;
}

.p-card {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

h4 {
  margin-bottom: 1rem;
  color: #495057;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
  font-weight: 600;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background-color: #e9ecef !important;
}

:deep(.p-datatable) {
  .p-datatable-thead > tr > th,
  .p-datatable-tbody > tr > td {
    padding: 0.5rem 1rem;
  }
}
</style>